import React from "react";

function Products(props) {
  return (
    <div>
      <div className="">
        <div className="hover:shadow-lg product_card p-2  bg-white  hover:text-black transition-all text-black  group">
          <div className="px-4 py-2">
            <div className="bg-white mb-3 w-full  relative  overflow-hidden">
              <div className="mx-auto w-full h-full  relative bg-transparent ">
                <img
                  src={props.img}
                  alt=""
                  srcSet=""
                  className="object-cover  mx-auto transition-all  hover:scale-110 overflow-hidden"
                />
              </div>
            </div>

            <h3 className="text-2xl font-medium text-center overflow-hidden">
              {props.title}
            </h3>
          </div>
          <div className="text-center pb-2 px-4">
            <button className="bg-black w-full py-2 hover:bg-transparent hover:text-black border-black border-2 transition-all text-white">
              View details
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Products;
